import { DEBUGGER_PROGRAM_LS_KEY } from '@pesto/hubble-shared/constants/local-storage-keys';

import { Program } from './program';
import type { HelocFlowConfig, ProgramConfig } from './program.types';
import { FlowType, programConfig } from './programConfig';

export const getProgram = (): Program => {
  const debuggerProgram = localStorage.getItem(DEBUGGER_PROGRAM_LS_KEY);

  if (debuggerProgram) {
    return debuggerProgram as Program;
  }

  const program = import.meta.env.VITE_PROGRAM;
  if (!program) {
    return Program.HOMELIGHT;
  }
  return program satisfies Program;
};

export const getCurrentProgramConfig = (): ProgramConfig => {
  const program = getProgram();
  const config = programConfig[program] ?? programConfig[Program.HOMELIGHT]!;
  if (!config) {
    throw new Error(`Program config not found for ${program}`);
  }
  return config;
};

export const getFlowConfig = <T extends ProgramConfig>(config: ProgramConfig): T => {
  return config as T;
};

export const isHelocFlow = (config: ProgramConfig): config is HelocFlowConfig => {
  return config.flowType === FlowType.HELOC;
};
